export default function modifyOrgList(orgList = [], searchText = '', currentOrg = null) {
  const addParentIds = (org, parentId) => {
    org.parentId = parentId;
    const matchesSearch =
      searchText &&
      org.slug.toLowerCase().includes(searchText.toLowerCase().replace(/[\s,]/g, '-'));
    const isCurrentOrg = currentOrg && org.slug === currentOrg.slug;

    if (matchesSearch || isCurrentOrg) {
      org.isOpen = true;
    } else org.isOpen = false;

    if (org.childOrgs && org.childOrgs.length > 0) {
      for (const child of org.childOrgs) {
        addParentIds(child, parentId);
      }
    }
  };

  for (const parentNode of orgList) {
    addParentIds(parentNode, parentNode.id);
  }

  //Check all orgs and its childOrgs if isOpen is true then mark it true for its parent

  const parentOrgsHandler = org => {
    const stringVal =
      org.childOrgs && org.childOrgs.length > 0 ? JSON.stringify(org.childOrgs) : '';
    if (stringVal.includes('isOpen":true')) {
      org.isOpen = true;

      //Check childOrgs if isOpen is true then mark it true for its parent
      if (org.childOrgs && org.childOrgs.length > 0) {
        for (const child of org.childOrgs) {
          parentOrgsHandler(child);
        }
      }
    } else org.isOpen = false;
  };

  for (const org of orgList) {
    parentOrgsHandler(org);
  }

  return [...orgList];
}
